import { createSelector } from 'reselect';

const _scopedState = (state) => state.entities.rulesets;
const rulesets = (state) => _scopedState(state).rulesets;
const hasFetched = (state) => _scopedState(state).hasFetched;
const isFetching = (state) => _scopedState(state).isFetching;

const rulesetsAsOptions = createSelector([rulesets], (rulesets) =>
  rulesets.map((ruleset) => ({
    value: ruleset.id,
    label: ruleset.name,
  }))
);

export default {
  rulesets,
  rulesetsAsOptions,
  hasFetched,
  isFetching,
};
